import {
  NOTIFICATION_STACKS,
  NotificationStackId,
} from "@/constants/notification";
import WorkspaceShell from "./workspace/WorkspaceShell";
import NotificationStack from "./notifications/NotificationStack";
import TrialBanner, { isTrialLocked } from "./TrialBanner";
import { useMyTrial } from "@/hooks/useMyTrial";
import { useAuthStore } from "@/store/useAuthStore";
import { isTeacher } from "@/utils/role-utils";

const Content = ({ children }: { children: React.ReactNode }) => {
  const { trial } = useMyTrial();
  const locked = trial ? isTrialLocked(trial) : false;
  const { user } = useAuthStore();
  const teacher = isTeacher(user?.role);

  return (
    <WorkspaceShell>
      <NotificationStack
        stack={NOTIFICATION_STACKS[NotificationStackId.BOTTOM_CENTER]}
      />
      <div className={locked ? "overflow-hidden max-h-screen" : ""}>
        {trial && (
          <TrialBanner
            trial={trial}
            showButton={teacher}
            isStudent={!teacher}
          />
        )}
        {children}
      </div>
    </WorkspaceShell>
  );
};

export default Content;
